module.exports = __webpack_public_path__ + "img/dg.dgb23bebb.svg";